// extracted by mini-css-extract-plugin
module.exports = {"root":"home-page_root__nfEfH","row":"home-page_row__SFtY7","column":"home-page_column__QmKl_"};